import React from 'react';

import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

import { BORDER_BOTTOM_VALUE } from './constants';

type ListItemStyleProps = {
  isHeader?: boolean;
};

type ListItemButtonProps = React.ComponentPropsWithoutRef<typeof Link> & ListItemStyleProps;

export const ListItemContent = ({ isHeader, style, ...props }: BoxProps & ListItemStyleProps) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.listItem,
      styles.listItemBorder,
      isHeader && styles.headerListItem,
      isWeb && styles.webListItemContent,
      style,
    ],
  });

export const ListItemButton = ({ isHeader, style, ...props }: ListItemButtonProps) =>
  React.createElement(Link, {
    ...props,
    style: [
      styles.listItem,
      styles.listItemBorder,
      styles.listItemButton,
      isHeader && styles.headerListItem,
      style,
    ],
  });

export const ProductControl = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.productControl, style],
  });

const styles = StyleSheet.create({
  headerListItem: {
    backgroundColor: primitive.$mayoEggWhite,
  },
  listItem: {
    alignItems: 'center',
    color: getDesignToken('text-default'),
    flexDirection: 'row',
    flexGrow: 1,
    justifyContent: 'space-between',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$4,
  },
  listItemBorder: {
    borderBottomColor: getDesignToken('border-color-default'),
    borderBottomWidth: BORDER_BOTTOM_VALUE,
  },
  listItemButton: {
    flexShrink: 1,
  },
  productControl: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: spacing.$2,
  },
  webListItemContent: {
    flex: 1,
  },
});
